// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"style_searchInput___a5h5","closeBtn":"style_closeBtn__KwGtG"};